import {
  getYear,
  subMonths,
  subYears,
  startOfYear,
  lastDayOfYear,
} from 'date-fns';
import { DateRangeKey } from './formik/transaction-filter/types';
import { endOfYearUTC, startOfMonthUTC, startOfYearUTC } from './date-utils';

type DateRange = {
  text: string;
  startDate: Date;
  endDate: Date;
};

const now = new Date();

export const dateRanges: Record<DateRangeKey, DateRange> = {
  thisYear: {
    text: 'This year',
    startDate: startOfYear(now),
    endDate: now,
  },
  lastSixMonths: {
    text: 'Last 6 months',
    startDate: subMonths(now, 6),
    endDate: now,
  },
  lastTwelveMonths: {
    text: 'Last 12 months',
    startDate: subMonths(now, 12),
    endDate: now,
  },
  previousYear: {
    text: String(getYear(subYears(now, 1))),
    startDate: startOfYear(subYears(now, 1)),
    endDate: lastDayOfYear(subYears(now, 1)),
  },
  previousTwoYear: {
    text: String(getYear(subYears(now, 2))),
    startDate: startOfYear(subYears(now, 2)),
    endDate: lastDayOfYear(subYears(now, 2)),
  },
};

export type DateRangeUTCId =
  | 'current_year'
  | 'last_3_months'
  | 'last_6_months'
  | 'last_12_months'
  | number;

type DateRangeUTC = {
  id: DateRangeUTCId;
  label: string;
  startDate: Date;
  endDate: Date;
};

const twoMonthsAgo = subMonths(now, 2);
const fiveMonthsAgo = subMonths(now, 5);
const elevenMonthsAgo = subMonths(now, 11);

export const dateRangesUTC: DateRangeUTC[] = [
  {
    id: 'current_year',
    label: 'This year',
    startDate: startOfYearUTC(now),
    endDate: endOfYearUTC(now),
  },
  {
    id: 'last_3_months',
    label: 'Last 3 months',
    // Note: Substract only 2 months in order to include the current month
    startDate: startOfMonthUTC(twoMonthsAgo),
    endDate: now,
  },
  {
    id: 'last_6_months',
    label: 'Last 6 months',
    // Note: Substract only 5 months in order to include the current month
    startDate: startOfMonthUTC(fiveMonthsAgo),
    endDate: now,
  },
  {
    id: 'last_12_months',
    label: 'Last 12 months',
    // Note: Substract only 11 months in order to include the current month
    startDate: startOfMonthUTC(elevenMonthsAgo),
    endDate: now,
  },
];
